import ManagerRepository from 'coreClasses/ManagerRepository';
import ProductModel from 'coreClasses/product/ProductModel';
import {ViewType} from 'brandConstants';
import {CustomerProductListItem} from 'coreStore/data/customerProductLists/types';

/**
 * Represents WishlistProductItemModel
 */
export default class WishlistProductItemModel {
	public variantId: string;
	public quantity: number;
	public price: number;
	public masterId: string;
	public name: string;
	public brand: string;
	public size: string;
	public color: string;
	public url: string;
	public image: string;
	public category: string;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {CustomerProductListItem} productItem - product item
	 */
	constructor(managerRepository: ManagerRepository, productItem: CustomerProductListItem) {
		const product = managerRepository.getProductsMgr().getProduct(productItem.productId) as ProductModel;
		const variationGroup = managerRepository.getProductsMgr().getProduct(
			productItem?.c_variationGroupId || product.getVariationGroupId(),
		) as ProductModel;

		this.variantId = productItem.productId;
		this.quantity = productItem.quantity;
		this.price = variationGroup.getPriceModel().getSales()?.value;

		this.masterId = product.getVariationGroupId();
		this.name = product.getName();
		this.brand = product.getBrand();
		this.size = product.getSize();
		this.color = product.getColorDescription();
		this.url = product.getProductUrl();
		this.image = (product.getProductImage as any)(ViewType.ZOOM, 0)?.getUrl();
		this.category = variationGroup.getPrimaryCategoryId();
	}
};
